/* ============================================================
   RYVA · Barrita de urgencia (reemplaza "Envío Gratis")
   Mensajes ROTATIVOS y cortos (no se parten, no empujan "Medidas"):
     ENVÍO GRATIS → SALE HOY EN HH:MM:SS → N VIENDO AHORA → …
   Cargado desde snippets/copy-toast.liquid (solo producto).
   i18n: textos desde window.RYVA_I18N (snippets/ryva-js-i18n.liquid).
         Los nombres de los días se generan con Intl según el idioma
         activo, así que no hay que traducirlos a mano.
   ------------------------------------------------------------
   AJUSTA AQUÍ tu corte real de envío:
   ============================================================ */
(function () {
  if (location.pathname.indexOf('/products/') === -1) return;

  function RY(k, fb) {
    var d = window.RYVA_I18N;
    return (d && typeof d[k] === 'string' && d[k].length) ? d[k] : fb;
  }
  var LOCALE = window.RYVA_LOCALE || document.documentElement.lang || 'es';

  var TZ = 'America/New_York'; // zona horaria de la tienda
  var CUTOFF_HOUR = 17;        // corte de envío (24h): 17 = 5:00 PM
  var CUTOFF_MIN = 0;
  var SHOW_VIEWERS = true;     // pon false para dejar solo la cuenta regresiva
  var ROTATE_MS = 4200;        // cada cuánto cambia de mensaje

  var DAYS_FALLBACK = ['DOMINGO', 'LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES', 'SÁBADO'];
  var WD = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  /* 2024-01-07 (UTC) fue domingo: idx 0=domingo … 6=sábado */
  var DAYS = (function () {
    try {
      var f = new Intl.DateTimeFormat(LOCALE, { weekday: 'long', timeZone: 'UTC' });
      var out = [];
      for (var i = 0; i < 7; i++) {
        out.push(f.format(new Date(Date.UTC(2024, 0, 7 + i))).toUpperCase());
      }
      return out;
    } catch (e) { return DAYS_FALLBACK; }
  })();

  function storeNow() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, hour12: false, weekday: 'short',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return { wd: WD[o.weekday], h: parseInt(o.hour, 10) % 24, m: parseInt(o.minute, 10), s: parseInt(o.second, 10) };
  }

  function state() {
    var n = storeNow();
    var cutoff = CUTOFF_HOUR * 3600 + CUTOFF_MIN * 60;
    var nowSec = n.h * 3600 + n.m * 60 + n.s;
    var business = n.wd >= 1 && n.wd <= 5;
    if (business && nowSec < cutoff) return { today: true, secs: cutoff - nowSec };
    var d = n.wd;
    do { d = (d + 1) % 7; } while (d === 0 || d === 6);
    return { today: false, day: DAYS[d] };
  }

  function pad(x) { return x < 10 ? '0' + x : '' + x; }
  function fmt(secs) {
    var h = Math.floor(secs / 3600), m = Math.floor((secs % 3600) / 60), s = secs % 60;
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  // "viendo ahora" — estable en la sesión, deriva lento (no salta en refresh)
  var viewers = (function () {
    try { var v = sessionStorage.getItem('ryva_urg_v'); if (v) return parseInt(v, 10); } catch (e) {}
    var n = 7 + Math.floor(Math.random() * 10); // 7–16
    try { sessionStorage.setItem('ryva_urg_v', n); } catch (e) {}
    return n;
  })();
  if (SHOW_VIEWERS) {
    setInterval(function () {
      viewers = Math.min(19, Math.max(5, viewers + (Math.random() < 0.5 ? -1 : 1)));
      try { sessionStorage.setItem('ryva_urg_v', viewers); } catch (e) {}
    }, 26000 + Math.floor(Math.random() * 12000));
  }

  var CSS =
    ".ryva-pdp-ship .ru-txt{display:inline-block;text-transform:uppercase;letter-spacing:.035em;font-weight:500;font-size:11px;line-height:1.15;color:#0a0a0a;white-space:nowrap;will-change:opacity,transform;}" +
    ".ryva-pdp-ship .ru-txt.ru-anim{animation:ruSwap .34s cubic-bezier(.22,.61,.36,1) both;}" +
    "@keyframes ruSwap{from{opacity:0;transform:translateY(4px);}to{opacity:1;transform:translateY(0);}}" +
    ".ryva-pdp-ship .ru-time{font-variant-numeric:tabular-nums;font-feature-settings:'tnum';font-weight:600;}" +
    ".ryva-pdp-ship .ru-view{color:#8f8f8f;}" +
    "@media (prefers-reduced-motion:reduce){.ryva-pdp-ship .ru-txt.ru-anim{animation:none;}}";

  function injectCss() {
    if (document.getElementById('ryva-urg-css')) return;
    var st = document.createElement('style');
    st.id = 'ryva-urg-css';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  function segHtml(i) {
    if (i === 0) return RY('free_shipping', 'Envío gratis');
    if (i === 1) {
      var st = state();
      return st.today
        ? RY('ships_today_in', 'Sale hoy en') + ' <span class="ru-time">' + fmt(st.secs) + '</span>'
        : RY('ships_on', 'Enviamos el') + ' ' + st.day;
    }
    return '<span class="ru-view">' + viewers + ' ' + RY('viewing_now', 'viendo ahora') + '</span>';
  }

  var txtEl = null;
  var count = SHOW_VIEWERS ? 3 : 2;
  var idx = 0;

  function retrigger() {
    txtEl.classList.remove('ru-anim');
    void txtEl.offsetWidth; // fuerza reinicio de la animación
    txtEl.classList.add('ru-anim');
  }

  function rotate() {
    idx = (idx + 1) % count;
    txtEl.innerHTML = segHtml(idx); // cambio instantáneo (sin hueco invisible)
    retrigger();                    // solo entrada suave
  }

  function tick() {
    if (idx !== 1 || !txtEl) return;
    var st = state();
    if (st.today) {
      var t = txtEl.querySelector('.ru-time');
      if (t) t.textContent = fmt(st.secs);   // solo dígitos, sin re-animar
      else { txtEl.innerHTML = segHtml(1); }
    } else {
      txtEl.innerHTML = segHtml(1);          // pasó el corte mientras se mostraba
    }
  }

  function boot() {
    var ship = document.querySelector('.ryva-pdp-ship');
    if (!ship) return false;
    injectCss();
    ship.innerHTML = '<span class="ryva-pdp-dot"></span><span class="ru-txt" data-ru></span>';
    txtEl = ship.querySelector('[data-ru]');
    txtEl.innerHTML = segHtml(0);
    setInterval(tick, 1000);
    setInterval(rotate, ROTATE_MS);
    return true;
  }

  function start() {
    if (boot()) return;
    var n = 0, iv = setInterval(function () { if (boot() || ++n > 25) clearInterval(iv); }, 300);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();